import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DOCTOR_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: data,
});
export const fetchspeciality = (speciality: any) => ({
    type: 'FETCH_SPEC_SUCCESS',
    payload: speciality,
});
export const fetchLan = (lan: any) => ({
    type: 'FETCH_LAN_SUCCESS',
    payload: lan,
});
export const getcou = (country: any) => ({
    type: 'FETCH_COUNTRY_SUCCESS',
    payload: country,
});
export const getsta = (state: any) => ({
    type: 'FETCH_STATE_SUCCESS',
    payload: state,
});
export const getname = (name: any) => ({
    type: 'FETCH_NAME_SUCCESS',
    payload: name,
});
export const state = (hcountry: any) => ({
    type: 'FETCH_SNAME_SUCCESS',
    payload: hcountry,
});
export const image = (image: any) => ({
    type: 'FETCH_IMAGE_SUCCESS',
    payload: image,
});
export const fetchdatasss = (adduploads: any) => ({
    type: 'FETCH_ADDUP_SUCCESS',
    payload: adduploads,
});



export const fetchDoctorDatasss = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = DOCTOR_API.doctorprofile_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchSpecialData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = DOCTOR_API.speciality_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchspeciality(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchlanguage = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = DOCTOR_API.language_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchLan(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getCountry = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = SUPRIVISOR_API.getcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(getcou(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getState = (country:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,countryId:country};
            const apiname = SUPRIVISOR_API.getstate;
            const response = await LoginService.getData(apiname,payload);
            dispatch(getsta(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getcountryname = (country:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:15,country:country};
            const apiname = SUPRIVISOR_API.scount;
            const response = await LoginService.getData(apiname,payload);
            dispatch(getname(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const gethcountryname = (country:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:15,country:country};
            const apiname = SUPRIVISOR_API.scount;
            const response = await LoginService.getData(apiname,payload);
            dispatch(state(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const apiname = DOCTOR_API.DoctorProfile_API;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(image(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData111 = (fileToUpload:any,uid:any,description:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = SUPRIVISOR_API.adddoc;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${description}-${fileToUpload}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(fetchdatasss(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};


